import { useOutletContext } from "react-router-dom";

import Unauthorized from "../../ui/components/Unauthorized/Unauthorized";

import useHasRight from "../../authorization/hooks/useHasRight";

import AgreementsExpiringView from "../views/AgreementsExpiringView/AgreementsExpiringView";

export default function AgreementsExpiring() {
	const { organization } = useOutletContext();

	const hasRight = useHasRight();

	if (!hasRight("agreements.view")) {
		return <Unauthorized />;
	}

	return <AgreementsExpiringView firstPartyId={organization.id} />;
}
